import logo from '../images/logo.png';
import LazyLoad from 'react-lazy-load';

export default React => props => {
  return (<div className="home section"  id="home">
    <LazyLoad>
      <img src={logo} alt="Logo Productora de Nuez SPR de RI" className="logo" />
    </LazyLoad>
    <h1>Productora de Nuez</h1>
    <h2>La calidad es el resultado de todos nuestros esfuerzos</h2>
    <a href="#about" className="btn">Conocenos</a>
  </div>);
}



// WEBPACK FOOTER //
// ./src/components/Home.js